module.exports = __webpack_public_path__ + "static/media/sdesk_screenshot_withframe_android.dfd6ee7c.png";